import * as types from '../actiontypes';
import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';

export function getUserSearch(searchKey, userLookUpType, resource) {
	const url = env.getBaseURL(serviceURL) + 'Users?searchString=' + searchKey + '&userLookupType=' + userLookUpType;
	return {
		type: types.GET_USER_SEARCH_GA,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}
